import React from 'react'
import './index.css'

export default function ContentLoader({
  backgroundColor = '#f0f0f0',
  foregroundColor = '#fafafa',
  children,
  className = '',
  style,
  ...props
}) {
  return (
    <div
      role="status"
      aria-busy="true"
      {...props}
      className={`evoshop-content-loader ${className}`}
      style={{
        '--loader-background': backgroundColor,
        '--loader-foreground': foregroundColor,
        ...style,
      }}
    >
      {children}
    </div>
  )
}
